import { Routes, Route, Navigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import MainLayout from "../layouts/mainLayout";
import Fallback from "../components/error";
import ProtectedRoute from "./protectedRoute";
import PublicRoute from "./publicRoute";
import { PUBLIC_ROUTES, PROTECTED_ROUTES } from "./config/routeConfig";


const AppRoutes = () => {
  return (
    <ErrorBoundary FallbackComponent={Fallback}>
      <Routes>
        {/* Public Routes */}
        {PUBLIC_ROUTES.map(({ path, element: Element }) => (
          <Route
            key={path}
            path={path}
            element={
              <PublicRoute>
                <Element />
              </PublicRoute>
            }
          />
        ))}

        {/* Protected Routes */}
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          {PROTECTED_ROUTES.map(({ path, element: Element }) => (
            <Route key={path} path={path} element={<Element />} />
          ))}
        </Route>

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
};

export default AppRoutes;